"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectValue = exports.MenuTrigger = exports.MenuItem = exports.InlineMenu = exports.Menu = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var react_aria_components_1 = require("react-aria-components");
var icons_1 = require("../icons");
var theme_1 = require("../theme");
var CheckboxGroup_1 = require("./Forms/CheckboxGroup");
var listStyles_1 = require("./listStyles");
/**
 * A menu displays a list of actions or options that a user can choose from.
 * It can be used for navigation, selection, or to trigger actions.
 *
 * @example
 * ```tsx
 * <MenuTrigger>
 *   <PrimaryButton>Trigger menu</PrimaryButton>
 *   <RACPopover>
 *     <Menu items={menuItems}>
 *       {(item) => (
 *         <MenuItem
 *           onAction={() => alert(`Pressed item: ${item.name}`)}
 *           id={item.id}
 *           isDisabled={item.disabled}
 *         >
 *           {item.name}
 *         </MenuItem>
 *       )}
 *     </Menu>
 *   </RACPopover>
 * </MenuTrigger>
 * ```
 *
 * @param items - The items to display in the menu
 * @param children - A function to render each menu item
 * @param selectionMode - The selection mode for the menu. Defaults to 'none'
 * @param selectedKeys - The currently selected keys. Defaults to empty set
 * @param onSelectionChange - Handler that is called when the selection changes
 * @param className - The CSS className for the element
 * @param style - The inline style for the element
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed, extended description for the object
 */
exports.Menu = (0, styled_1.default)(react_aria_components_1.Menu)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 560px;\n  ", "\n"], ["\n  max-width: 560px;\n  ", "\n"])), listStyles_1.ListStyles);
exports.InlineMenu = (0, styled_1.default)(react_aria_components_1.Menu)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var StyledMenuItem = (0, styled_1.default)(react_aria_components_1.MenuItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  gap: ", ";\n  border-radius: ", ";\n  text-overflow: ellipsis;\n  white-space: normal;\n  overflow: hidden;\n  outline: none;\n  cursor: default;\n  text-decoration: none;\n  line-height: ", ";\n  height: 100%;\n  width: 100%;\n\n  ", "\n\n  &[data-disabled] {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  gap: ", ";\n  border-radius: ", ";\n  text-overflow: ellipsis;\n  white-space: normal;\n  overflow: hidden;\n  outline: none;\n  cursor: default;\n  text-decoration: none;\n  line-height: ", ";\n  height: 100%;\n  width: 100%;\n\n  ", "\n\n  &[data-disabled] {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n"])), theme_1.theme.space.space12, theme_1.theme.space.space8, theme_1.theme.radii.field, theme_1.theme.lineHeights.body, listStyles_1.ListItemStyles, theme_1.theme.opacity.semiOpaque);
var ContentContainer = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-width: 0;\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  min-width: 0;\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])));
/**
 * A menu item represents a single option or action in a menu.
 * It can be used for navigation (with href), selection, or to trigger actions.
 *
 * @example
 * ```tsx
 * <MenuItem onAction={() => alert('Clicked')}>
 *   Menu Item
 * </MenuItem>
 * ```
 *
 * @param children - The content to display in the menu item
 * @param textValue - A string representation of the item's contents, used for features like typeahead
 * @param onAction - Handler that is called when the item is selected
 * @param href - A URL to link to
 * @param isDisabled - Whether the item is disabled. Defaults to false
 * @param id - The unique id of the item
 * @param className - The CSS className for the element
 * @param style - The inline style for the element
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed, extended description for the object
 */
var MenuItem = function (_a) {
    var children = _a.children, isDestructive = _a.isDestructive, props = __rest(_a, ["children", "isDestructive"]);
    return (react_1.default.createElement(StyledMenuItem, __assign({}, props, { "data-destructive": isDestructive }), function (_a) {
        var isSelected = _a.isSelected, selectionMode = _a.selectionMode;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            selectionMode === 'multiple' && (react_1.default.createElement(CheckboxGroup_1.CheckboxElement, { isSelected: isSelected, isIndeterminate: false, isPressed: false, isFocusVisible: false, isInvalid: false })),
            react_1.default.createElement(ContentContainer, null, children),
            selectionMode === 'single' && isSelected && (react_1.default.createElement(icons_1.CheckIcon, { size: 20, style: { marginLeft: 'auto' } }))));
    }));
};
exports.MenuItem = MenuItem;
/**
 * The trigger element for a menu.
 * The menu will be shown when the user clicks or presses the trigger element.
 *
 * @example
 * ```tsx
 * <MenuTrigger>
 *   <PrimaryButton>Open Menu</PrimaryButton>
 *   <RACPopover>
 *     <Menu>
 *       <MenuItem>Menu Item 1</MenuItem>
 *       <MenuItem>Menu Item 2</MenuItem>
 *     </Menu>
 *   </RACPopover>
 * </MenuTrigger>
 * ```
 *
 * @param children - The trigger element and menu content to display
 * @param isOpen - Whether the menu is open by default (controlled). Defaults to false
 * @param defaultOpen - Whether the menu is open by default (uncontrolled). Defaults to false
 * @param onOpenChange - Handler that is called when the menu's open state changes
 * @param isDisabled - Whether the menu trigger is disabled. Defaults to false
 */
var MenuTrigger = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(react_aria_components_1.MenuTrigger, __assign({}, props), children));
};
exports.MenuTrigger = MenuTrigger;
var StyledSpan = styled_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n"], ["\n  display: flex;\n  flex-grow: 1;\n"])));
var MultiSelectValue = function (_a) {
    var selectedKeys = _a.selectedKeys, items = _a.items, placeholder = _a.placeholder, pluralLabel = _a.pluralLabel, labelKey = _a.labelKey;
    // Handle the special 'all' case
    if (selectedKeys === 'all') {
        return react_1.default.createElement(StyledSpan, null,
            "All ",
            pluralLabel || 'items');
    }
    // Convert Selection to array for easier handling
    var selectedItems = selectedKeys ? Array.from(selectedKeys) : [];
    if (selectedItems.length === 0) {
        return (react_1.default.createElement(StyledSpan, null, placeholder || "Select ".concat(pluralLabel || 'item')));
    }
    if (selectedItems.length === 1) {
        var selectedItem = items
            ? Array.from(items).find(function (item) { return item.id === selectedItems[0]; })
            : undefined;
        if (selectedItem && labelKey) {
            return react_1.default.createElement(StyledSpan, null, selectedItem[labelKey]);
        }
        return react_1.default.createElement(StyledSpan, null, selectedItems[0]);
    }
    return (react_1.default.createElement(StyledSpan, null,
        selectedItems.length,
        " ",
        pluralLabel || 'items'));
};
exports.MultiSelectValue = MultiSelectValue;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Menu.js.map